import { useEffect, useRef } from 'react';
import { defineMessages, useIntl } from 'react-intl';

const msgs = defineMessages({
  msg1: {
    id: 'new_plans_tab_retention_1',
    defaultMessage: '👋 Wait! Don\u2019t miss out...',
  },
  msg2: {
    id: 'new_plans_tab_retention_2',
    defaultMessage: '🔥 Special offer just for you!',
  },
});

const CYCLE_MS = 2000;

export function useTabRetention() {
  const intl = useIntl();
  const originalTitle = useRef(document.title);
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);

  useEffect(() => {
    const savedTitle = originalTitle.current;
    const messages = [intl.formatMessage(msgs.msg1), intl.formatMessage(msgs.msg2)];
    let index = 0;

    const handleVisibility = () => {
      if (document.visibilityState === 'hidden') {
        index = 0;
        document.title = messages[index];
        intervalRef.current = setInterval(() => {
          index = (index + 1) % messages.length;
          document.title = messages[index];
        }, CYCLE_MS);
      } else {
        if (intervalRef.current) {
          clearInterval(intervalRef.current);
          intervalRef.current = null;
        }
        document.title = savedTitle;
      }
    };

    document.addEventListener('visibilitychange', handleVisibility);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibility);
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
      document.title = savedTitle;
    };
  }, [intl]);
}
